import { Queue } from '@cian/event-queue';

import { TEvents } from '../../types/events';

/**
 * Возвращает общую с микрофронтендами очередь событий.
 *
 * В браузере это синглтон window.eventQueue: если его ещё нет, создаём и кешируем обратно
 * на window, чтобы хост и микрофронтенд работали с одним инстансом. Возврат не закешированной
 * очереди — баг: подписавшись раньше микрофронтенда, хост слушал бы выброшенный инстанс.
 * Вне браузера (SSR) отдаём отдельную пустую очередь.
 */
export const getEventQueue = (): Queue<TEvents> => {
  if (typeof window !== 'undefined') {
    return window.eventQueue || (window.eventQueue = new Queue<TEvents>());
  }

  return new Queue<TEvents>();
};
